import { useGetOrderSummaries } from '@/api/documents/documents.hooks';
import { formatMoneyString } from '@utils/format-money-string';
import Button from '@components/base/button.component';
import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

export function RecentOrdersSection() {
  const { data, isLoading } = useGetOrderSummaries(1);
  const navigate = useNavigate();

  const orders = data?.data?.slice(0, 5) ?? [];

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 1.5,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: 'text.secondary',
            fontSize: '0.75rem',
          }}
        >
          Letzte Bestellungen
        </Typography>
        <Button
          size="small"
          endIcon={<ArrowForward sx={{ fontSize: '14px !important' }} />}
          onClick={() => navigate('/bp/c/orders')}
          sx={{ fontSize: '0.75rem' }}
        >
          Alle Bestellungen
        </Button>
      </Box>

      {isLoading ? (
        <Stack spacing={1}>
          {[...Array(3)].map((_, i) => (
            <Skeleton
              key={i}
              variant="rounded"
              height={44}
              sx={{ borderRadius: 2 }}
            />
          ))}
        </Stack>
      ) : orders.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          Noch keine Bestellungen vorhanden
        </Typography>
      ) : (
        <Stack spacing={0}>
          {orders.map((order) => (
            <Box
              key={order.docEntry}
              onClick={() => navigate(`/bp/c/orders/${order.docEntry}`)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                px: 1.5,
                py: 1,
                borderRadius: 2,
                cursor: 'pointer',
                transition: 'background-color 0.15s',
                '&:hover': { bgcolor: 'action.hover' },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, fontSize: '0.82rem', flex: 1 }}
              >
                #{order.docNum}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  fontSize: '0.75rem',
                  mx: 2,
                  display: { xs: 'none', sm: 'block' },
                }}
              >
                {dayjs(order.docDate).format('DD.MM.YYYY')}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 700,
                  fontSize: '0.82rem',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {formatMoneyString(order.docTotal)}
              </Typography>
            </Box>
          ))}
        </Stack>
      )}
    </Box>
  );
}
